<script setup>
const props = defineProps(['title', 'index']);

import { useCommonStore } from '../stores/common';

const store = useCommonStore();
const activeIndex = computed(() => store.contactAccordionIndex);
const { setContactsAccordionIndex } = store;
</script>

<template>
  <div class="accordion-item">
    <div @click="setContactsAccordionIndex(index === activeIndex ? null : index)" class="accordion-item__label" :class="{ collapsed: index != activeIndex }">
      <h2 class="heading heading--3 heading--upper">
        {{ title }}
      </h2>
    </div>
    <div :class="{ 'accordion-item__content': true, collapsed: index != activeIndex, open: index === activeIndex }">
      <div class="accordion-item__content-inner" :class="{ collapse: index != activeIndex }">
        <slot />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.accordion-item {
  margin-bottom: 10px;

  &__label {
    cursor: pointer;
  }

  &__content {
    transition: 0.3s ease-out;
    &.collapsed {
      height: 0;
      overflow: hidden;
      transition: 0.3s ease-out;
    }
  }

  &__content-inner {
    opacity: 1;
    transition: 0.5s ease-out;
    &.collapse {
      opacity: 0;
      transition: 0.5s ease-out;
    }
  }

  &.open {
    max-height: 500px; /* Adjust as needed */
  }
}

.accordion-item {
  padding: 15px 40px 15px 0;
  border-bottom: 1px solid $silver;

  &:first-child {
    border-top: 1px solid $silver;
  }

  &__label {
    position: relative;
    cursor: pointer;
    user-select: none;

    &:focus {
      outline: 0;
    }

    &:before,
    &:after {
      background: $black;
      content: '';
      display: block;
      height: 14px;
      position: absolute;
      margin-top: -9px;
      right: -26px;
      top: 50%;
      transform-origin: 100% 100%;
      transition: transform 300ms;
      width: 1px;
    }
    &:before {
      transform: translateY(-9px) rotate(-135deg);
    }
    &:after {
      transform: translateY(-9px) rotate(135deg);
    }

    &.collapsed {
      &:before {
        transform: rotate(-45deg);
      }
      &:after {
        transform: rotate(45deg);
      }
    }
  }

  &__content {
    padding-bottom: 15px;
    &.collapsed {
      padding: 0;
    }
  }

  &__content-inner {
    padding-top: 25px;
  }
}
</style>
